export default {
  en: {
    'bundles-registrations-registrations-detail-page-components.registration-de-register-form.date.label':
      'De-registration date',
    'bundles-registrations-registrations-detail-page-components.registration-de-register-form.action.submit':
      'Save',
    'bundles-registrations-registrations-detail-page-components.registration-de-register-form.action.cancel':
      'Cancel',
    'bundles-registrations-registrations-detail-page-components.registration-de-register-form.fallback-error':
      'Error de-registering registration, please try again.',
    'bundles-registrations-registrations-detail-page-components.registration-de-register-form.success':
      'Registration de-registered successfully',

    'bundles-registrations-registrations-detail-page-components.registration-de-register-form.date.required':
      'Please select a de-registration date',
    'bundles-registrations-registrations-detail-page-components.registration-de-register-form.date.invalid':
      'Please enter a valid date',
    'bundles-registrations-registrations-detail-page-components.registration-de-register-form.date.max-date-message':
      'Date should not be after maximal date',
    'bundles-registrations-registrations-detail-page-components.registration-de-register-form.date.min-date-message':
      'Should not be before registration date',
  },
};
